/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { renderList } from "common/vue/render-list";
import "./Select.scss";

function Select({
  options = [],
  placeholder = "Select an option",
  value = null,
  disabled = false,
  onChange = () => {},
  ...restProps
}) {
  const [visible, setVisible] = useState(false);

  function displayValue() {
    if (value) {
      // @ts-expect-error TS(2339): Property 'label' does not exist on type 'never'.
      return value.label;
    }
    return placeholder;
  }

  function labelPrefix() {
    // @ts-expect-error TS(2339): Property 'prefix' does not exist on type 'never'.
    return value?.prefix;
  }

  function disableOpen() {
    return disabled || options.length === 0;
  }

  // @ts-expect-error TS(7031): Binding element 'itemValue' implicitly has an 'any... Remove this comment to see the full error message
  function isCurrentValue({ value: itemValue }) {
    // @ts-expect-error TS(2339): Property 'value' does not exist on type 'never'.
    return itemValue === value?.value;
  }

  function toggle() {
    if (disableOpen()) {
      return;
    }
    setVisible(!visible);
  }

  function select(option: any) {
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    onChange(option.value);
    toggle();
  }

  function handleFocusOut(event: any) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setVisible(false);
    }
  }

  return (
    <div
      {...restProps}
      className="select scope-de2e26f7"
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
      tabIndex="0"
      onBlur={handleFocusOut}
      data-testid="select"
    >
      <div
        className={cn("select__selector scope-de2e26f7", disabled && "select__selector--disabled")}
        onClick={() => toggle()}
        data-testid="select-selector"
      >
        {labelPrefix() ? (
          <img
            className="select__prefix scope-de2e26f7"
            src={labelPrefix()}
            data-testid="select-prefix"
          />
        ) : null}
        <div
          className={cn("select__text scope-de2e26f7", !value && "select__text--placeholder")}
          data-testid="select-text"
        >
          {displayValue()}
        </div>
        <UseSvg
          className={cn("select__arrow scope-de2e26f7", visible && "select__arrow--expanded")}
          icon="arrow-right"
          data-testid="select-arrow"
        />
        <div
          className={cn("select__menu scope-de2e26f7", !visible && "hidden")}
          data-testid="select-menu"
        >
          <ul className="select__list scope-de2e26f7" data-testid="select-list">
            {renderList(options, item => (
              <li
                className={cn(
                  "select__list-item scope-de2e26f7",
                  isCurrentValue(item) && "select__list-item--current"
                )}
                key={item.value}
                onClick={e => {
                  e.stopPropagation();
                  select(item);
                }}
                data-testid="select-list-item"
              >
                {item.prefix ? (
                  <img
                    className="select__prefix scope-de2e26f7"
                    src={item.prefix}
                    data-testid="select-prefix-1"
                  />
                ) : null}
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Select;
